/*!

=========================================================
* Paper Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { NavLink } from "react-router-dom";
import {
  Nav,
  Collapse,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import avatar from "../../../assets/img/default-avatar.png";
import slogo from "../../../assets/img/s-logo.png";
import sortdLogo from "../../../assets/img/sortdlogol.png";

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.getCollapseStates(props.routes),
      logoutModal: false,
    };
  }
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = (routes) => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState,
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.js - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.pathname.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = (routes) => {
    return routes.map((prop, key) => {
      if (prop.redirect) {
        return null;
      }
      if(this.props.projectDetails && this.props.projectDetails.webstoryOnlyDashboard && !prop.webstoryOnlyRoute){
        return null;
      }
      if(prop.visible === false){
        return null;
      }
      if (prop.requiresV2AppConfig) {
        const pd = this.props.projectDetails || {};
        if (!pd.isV2enabled) {
          return null;
        }
      }
      if (prop.requiresPlatform) {
        const pd = this.props.projectDetails || {};
        if (prop.requiresPlatform === 'android' && !pd.android_app_enabled) {
          return null;
        }
        if (prop.requiresPlatform === 'ios' && !pd.ios_app_enabled) {
          return null;
        }
      }
      if (prop.requiresAdmin) {
        const rolesFromUser =
          (this.props.userdetails &&
            (this.props.userdetails.current_user_roles ||
            this.props.userdetails.roles ||
            this.props.userdetails.user_roles)) ||
          [];
        const rolesFromProjectDetails =
            (this.props.projectDetails && this.props.projectDetails.current_user_roles) ||
            [];
        const roles = rolesFromUser.length ? rolesFromUser : rolesFromProjectDetails;
        const isAdminOrOwner =
            roles.includes("admin") || roles.includes("owner");

          if (roles.length > 0 && !isAdminOrOwner) {
            return null;
          }
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          <li
            style = {prop.visible?{display:''}:{display:'none'}}
            className={this.getCollapseInitialState(prop.views) ? "active" : ""}
            key={key}
          >
            <a
              href="#pablo"
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              onClick={(e) => {
                e.preventDefault();
                this.setState(st);
              }}
            >
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>
                    {prop.name}
                    <b className="caret" />
                  </p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">
                    {prop.name}
                    <b className="caret" />
                  </span>
                </>
              )}
            </a>
            <Collapse isOpen={this.state[prop.state]}>
              <ul className="nav">{this.createLinks(prop.views)}</ul>
            </Collapse>
          </li>
        );
      }
      
      let toPath = prop.layout + prop.path;

      if (prop.defaultQuery && typeof prop.defaultQuery === 'object') {
        const qsParams = new URLSearchParams(prop.defaultQuery);
        if (this.props.projectDetails && this.props.projectDetails.slug) {
          qsParams.set("project", this.props.projectDetails.slug);
        }
        const qs = qsParams.toString();
        if (qs) {
          toPath = toPath + '?' + qs;
        }
        return (
          <li className={this.activeRoute(prop.layout + prop.path)} key={key}>
            <NavLink to={toPath} activeClassName="">
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>{prop.name}</p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">{prop.name}</span>
                </>
              )}
            </NavLink>
          </li>
        );
      }
      let liActiveClass = this.activeRoute(prop.layout + prop.path);
      if (prop.sidebarResolveInstanceId && prop.path && prop.path.indexOf(":instanceId") !== -1) {
        const instanceId =
          this.props.projectDetails && this.props.projectDetails.dynamicConfigInstanceId;
        if (!instanceId) {
          return null;
        }
        toPath = prop.layout + prop.path.replace(":instanceId", instanceId);
        const dynamicPrefix = `${prop.layout}/dynamic-config/`;
        liActiveClass =
          this.props.location.pathname.indexOf(dynamicPrefix) > -1 ? "active" : "";
      }

      if (prop.defaultQuery && typeof prop.defaultQuery === 'object') {
        const qsParams = new URLSearchParams(prop.defaultQuery);
        if (this.props.projectDetails && this.props.projectDetails.slug) {
          qsParams.set("project", this.props.projectDetails.slug);
        }
        const qs = qsParams.toString();
        if (qs) {
          toPath = toPath + '?' + qs;
        }
      }
      
      // external link — plain <a> so browser does a full page load
      if (prop.externalLink) {
        const instanceId =
          this.props.projectDetails && this.props.projectDetails.dynamicConfigInstanceId;
        if (prop.sidebarResolveInstanceId && !instanceId) {
          return null;
        }
        const extPath = prop.path || "";
        const locPath =
          this.props.location && this.props.location.pathname ? this.props.location.pathname : "";
        const extActive =
          extPath !== "" &&
          (locPath === extPath || locPath.startsWith(extPath + "/"));
        return (
          <li className={extActive ? "active" : ""} key={key}>
            <a href={prop.path}>
              {prop.icon !== undefined ? (
                <>
                  <i className={prop.icon} />
                  <p>{prop.name}</p>
                </>
              ) : (
                <>
                  <span className="sidebar-mini-icon">{prop.mini}</span>
                  <span className="sidebar-normal">{prop.name}</span>
                </>
              )}
            </a>
          </li>
        );
      }

      return (
        <li className={liActiveClass} key={key}>
    <NavLink to={toPath} activeClassName="">
      {prop.icon !== undefined ? (
        <>
          <i className={prop.icon} />
          <p>{prop.name}</p>
        </>
      ) : (
        <>
          <span className="sidebar-mini-icon">{prop.mini}</span>
          <span className="sidebar-normal">{prop.name}</span>
        </>
      )}
    </NavLink>
  </li>
);
    });
  };
  // verifies if routeName is the one active (in browser input)
  activeRoute = (routeName) => {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  toggleLogoutModal = () => {
    this.setState({
      logoutModal: !this.state.logoutModal,
    });
  };
  handleLogout = () => {
    window.location.href = "/auth/logout";
  };
  componentDidMount() {
    // if you are using a Windows Machine, the scrollbars will have a Mac look
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebar, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentWillUnmount() {
    // we need to destroy the false scrollbar when we navigate
    // to a page that doesn't have this component rendered
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  
  render() {
    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
<Modal
          isOpen={this.state.logoutModal}
          toggle={this.toggleLogoutModal}
          centered
        >
          <ModalHeader className="justify-content-center border-0 pb-0">
            Confirm Logout
          </ModalHeader>
          <ModalBody className="text-center pt-4">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              size="3x"
              className="text-warning mb-3"
            />
            <h4>Are you sure you want to log out?</h4>
            <p className="text-muted">
              You will need to sign in again to access your account.
            </p>
          </ModalBody>
          <ModalFooter className="justify-content-center border-0 pt-0">
            <Button
              color="danger"
              onClick={this.handleLogout}
              style={{ minWidth: "120px" }}
            >
              Yes, Logout
            </Button>
            <Button
              color="secondary"
              outline
              onClick={this.toggleLogoutModal}
              style={{ minWidth: "120px" }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        <div className="logo">
          <a href="/" className="simple-text logo-mini" >
            <div className="logo-img">
              <img src={slogo} alt="small-logo" />
            </div>
          </a>
          <a href="/dashboard/home"  className="simple-text logo-normal" > <img src={sortdLogo} alt="Sortd logo" /> </a>
        </div>

        <div className="sidebar-wrapper" ref="sidebar">
          <div className="user">
            <div className="photo">
              <img src={avatar} alt="Avatar" />
            </div>
            <div className="info">
              <a
                href="#pablo"
                data-toggle="collapse"
                aria-expanded={this.state.openAvatar}
                onClick={() =>
                  this.setState({ openAvatar: !this.state.openAvatar })
                }
              >
                <span>
                  {this.props.userdetails.name?this.props.userdetails.name:''}
                  <b className="caret" />
                </span>
              </a>
              <Collapse isOpen={this.state.openAvatar}>
                <ul className="nav">
                  <li>
                    <a
                      href="#pablo"
                      onClick={(e) => {
                        e.preventDefault();
                        this.toggleLogoutModal();
                      }}
                    >
                      <span className="sidebar-mini-icon">L</span>
                      <span className="sidebar-normal">Logout</span>
                    </a>
                  </li>
                </ul>
              </Collapse>
            </div>
          </div>
          <Nav className="parent-item">{this.createLinks(this.props.routes)}</Nav>
        </div>
      </div>
    );
  }
}

export default Sidebar;